var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7608_68968)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.2215 11.0479C9.35918 11.1112 9.5143 11.1256 9.66129 11.0889C9.80828 11.0522 9.93839 10.9665 10.0302 10.8459L10.2668 10.5359C10.391 10.3703 10.5521 10.2359 10.7372 10.1434C10.9224 10.0508 11.1265 10.0026 11.3335 10.0026H13.3335C13.6871 10.0026 14.0263 10.1431 14.2763 10.3931C14.5264 10.6432 14.6668 10.9823 14.6668 11.3359V13.3359C14.6668 13.6896 14.5264 14.0287 14.2763 14.2787C14.0263 14.5288 13.6871 14.6693 13.3335 14.6693C10.1509 14.6693 7.09865 13.405 4.84821 11.1546C2.59778 8.90412 1.3335 5.85187 1.3335 2.66927C1.3335 2.31565 1.47397 1.97651 1.72402 1.72646C1.97407 1.47641 2.31321 1.33594 2.66683 1.33594H4.66683C5.02045 1.33594 5.35959 1.47641 5.60964 1.72646C5.85969 1.97651 6.00016 2.31565 6.00016 2.66927V4.66927C6.00016 4.87626 5.95197 5.08041 5.8594 5.26556C5.76683 5.4507 5.63242 5.61174 5.46683 5.73594L5.15483 5.96994C5.03244 6.06339 4.94618 6.19633 4.91069 6.34617C4.8752 6.49601 4.89268 6.65352 4.96016 6.79194C5.87128 8.64251 7.36978 10.1391 9.2215 11.0479Z",
    stroke: "#757575",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7608_68968"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.df8a28eb289f71bcfe385a8c5689e8be.svg";
export { ForwardRef as ReactComponent };